"use strict";
/*
 * Membrane React package
 * {@link https://www.npmjs.com/package/@membranehq/react}
 * v0.29.2
 */
'use client';

import { jsxs, jsx } from 'react/jsx-runtime';
import { clsx } from 'clsx';
import { forwardRef, useState, useEffect } from 'react';
import { dropdownRecipe } from '../../recipes/dropdown.mjs';
import { Skeleton } from '../../ui-kit/skeleton.mjs';

const LoadingItem = forwardRef(({ className, delay = 300, ...props }, ref) => {
  const styles = dropdownRecipe();
  const [shouldShow, setShouldShow] = useState(delay === 0);
  useEffect(() => {
    if (delay !== 0) {
      const timer = setTimeout(() => {
        setShouldShow(true);
      }, delay);
      return () => clearTimeout(timer);
    }
    return () => {
    };
  }, []);
  if (!shouldShow) {
    return null;
  }
  return /* @__PURE__ */ jsxs("div", { className: clsx("flex", styles["loading-item-container"], className), ...props, ref, children: [
    /* @__PURE__ */ jsx(Skeleton, { className: styles["loading-item-icon"] }),
    /* @__PURE__ */ jsx(Skeleton, { className: styles["loading-item-title"] })
  ] });
});

export { LoadingItem };
